import { Controller } from "@hotwired/stimulus"

import { OTHER, isDerivedUrl, trackingUrlFor } from "../lib/shippingCarriers"

export default class extends Controller {
  static targets = ["select", "customRow", "customInput", "hidden", "website", "tracking"]
  static values = { carriers: Object }

  connect() {
    this.syncCarrierUi()
    if (this.selectTarget.value === OTHER) return

    this.syncWebsite(this.selectTarget.value || null)
    this.hiddenTarget.value = this.selectTarget.value || ""
    this.customInputTarget.value = ""
  }

  update() {
    const previousCarrier = this.hiddenTarget.value
    this.syncCarrierUi()
    this.syncWebsite(previousCarrier)
    if (this.selectTarget.value === OTHER) return

    this.hiddenTarget.value = this.selectTarget.value || ""
    this.customInputTarget.value = ""
  }

  updateTracking() {
    const carrier = this.selectTarget.value
    if (carrier === OTHER || !carrier) return

    this.syncWebsite(carrier)
  }

  updateCustom() {
    if (this.selectTarget.value === OTHER) {
      this.hiddenTarget.value = this.customInputTarget.value
    }
  }

  syncCarrierUi() {
    const carrier = this.selectTarget.value
    this.customRowTarget.style.display = carrier === OTHER ? "block" : "none"

    if (carrier === OTHER) {
      this.hiddenTarget.value = this.customInputTarget.value
    }
  }

  syncWebsite(carrier) {
    if (!isDerivedUrl(this.carriersValue, this.websiteTarget.value, carrier)) return

    this.websiteTarget.value = trackingUrlFor(
      this.carriersValue,
      this.selectTarget.value,
      this.hasTrackingTarget ? this.trackingTarget.value : "",
    )
  }
}
